import PropTypes from 'prop-types';
import React from 'react';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';
import Report from '../../../common/components/Report';

const ThresholdsForCertificationReport = props => (
  <Report
    id={props.id}
    tabs={[
      {
        value: ReportDefinitions.THRESHOLDS_FOR_CERTIFICATION_545_SUMMARY.id,
        label: 'Summary',
      },
      {
        value: ReportDefinitions.THRESHOLDS_FOR_CERTIFICATION_545_DETAILS.id,
        label: 'Details',
        loadFromTable: true,
        loadFromTableMessage: 'app.warning.load.from.summary.report',
      },
    ]}
    {...props}
  />
);
export default ThresholdsForCertificationReport;

ThresholdsForCertificationReport.propTypes = {
  id: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  generatedOnDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  reportId: PropTypes.string,
  showLegendThresholdsForCertification: PropTypes.bool,
  closeChart: PropTypes.func,
};
